export default __webpack_public_path__ + "static/germaine2-17244cb312d4baebf4e48212476b04c0.jpg";